<template>
  <div class="interest-rate">
    <div class="form-group row">
      <div
        :class="'col-md-2 form-group ' + (validations !== null && validations.hasOwnProperty('start_amount') ? 'has-error' : '')"
      >
        <label class="required">{{ $t('fields.startAmount') }}</label>
        <input
          type="number"
          class="form-control"
          v-model="interestRate.start_amount"
          :placeholder="$t('fields.startAmount')"
        >
        <span
          class="label-error"
          v-if="validations !== null && validations.hasOwnProperty('start_amount')"
        >
          {{ validations['start_amount'][0] }}
        </span>
      </div>
      <div
        :class="'col-md-2 form-group ' + (validations !== null && validations.hasOwnProperty('end_amount') ? 'has-error' : '')"
      >
        <label class="required">{{ $t('fields.endAmount') }}</label>
        <input
          type="number"
          class="form-control"
          v-model="interestRate.end_amount"
          :placeholder="$t('fields.endAmount')"
        >
        <span
          class="label-error"
          v-if="validations !== null && validations.hasOwnProperty('end_amount')"
        >
          {{ validations['end_amount'][0] }}
        </span>
      </div>
      <div
        :class="'col-md-2 form-group ' + (validations !== null && validations.hasOwnProperty('start') ? 'has-error' : '')"
      >
        <label class="required">{{ $t('fields.startDay') }}</label>
        <input
          type="number"
          class="form-control"
          v-model="interestRate.start"
          :placeholder="$t('fields.startDay')"
        >
        <span
          class="label-error"
          v-if="validations !== null && validations.hasOwnProperty('start')"
        >
          {{ validations['start'][0] }}
        </span>
      </div>

      <div
        :class="'col-md-2 form-group ' + (validations !== null && validations.hasOwnProperty('end') ? 'has-error' : '')"
      >
        <label class="required">{{ $t('fields.endDay') }}</label>
        <input
          type="number"
          class="form-control"
          v-model="interestRate.end"
          :placeholder="$t('fields.endDay')"
        >
        <span
          class="label-error"
          v-if="validations !== null && validations.hasOwnProperty('end')"
        >
          {{ validations['end'][0] }}
        </span>
      </div>

      <div
        :class="'col-md-4 form-group ' + (validations !== null && validations.hasOwnProperty('percentage') ? 'has-error' : '')"
      >
        <label class="required">{{ $t('fields.percentage') }}</label>
        <input
          type="number"
          class="form-control"
          v-model="interestRate.percentage"
          :placeholder="$t('fields.percentage')"
        >
        <span
          class="label-error"
          v-if="validations !== null && validations.hasOwnProperty('percentage')"
        >
          {{ validations['percentage'][0] }}
        </span>
      </div>
    </div>

    <div class="form-group row">
      <div class="col-md-12">
        <template v-if="editable">
          <button
            @click="onClickUpdate"
            class="btn btn-primary margin-right-5 btn-sm btn-update"
          >
            {{ $t('buttons.save') }}
          </button>
        </template>
        <button
          @click="onClickBack"
          class="btn btn-default btn-sm btn-back"
        >
          {{ $t('buttons.cancel') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PayDayLoanInterestRateForm',
  props: {
    editable: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      interestRate: {
        percentage: null,
        start: null,
        end: null,
        start_amount: null,
        end_amount: null
      },
      id: null,
      validations: null
    }
  },
  methods: {
    onClickBack () {
      this.$router.push({
        name: 'InterestRate'
      })
    },
    onClickUpdate () {
      const self = this
      this.$isLoading(true)
      this.$axios.post(process.env.VUE_APP_API + '/api/v1/interest-rate/store', this.interestRate)
        .then((response) => {
          this.$isLoading(false)
          if (response.data.code === 1) {
            this.$toastr(
              'success',
              self.$t('string.theRecordWasUpdated'),
              self.$t('string.interestRate')
            )
            this.onClickBack()
          }
          if (response.data.code === 0) {
            this.validations = response.data.message
          }
        })
        .catch((error) => {
          this.onResponseError(error)
        })
    },
    getInterestRate () {
      this.$isLoading(true)
      this.$axios.post(process.env.VUE_APP_API + '/api/v1/interest-rate/get-interest-rate', {
        id: this.$route.params.id
      })
        .then((response) => {
          this.$isLoading(false)
          if (response.data.code === 1 && response.data.data !== null) {
            this.interestRate = response.data.data
          }
        })
        .catch((error) => {
          this.onResponseError(error)
        })
    }
  },
  mounted () {
    this.$nextTick(() => {
      if (!this.editable) {
        $('input').attr('disabled', 'disabled')
      }

      if (this.$route.params.hasOwnProperty('id')) {
        this.getInterestRate()
      }
    })
  }
}
</script>

<style scoped>

</style>
